import { UntypedFormControl } from '@angular/forms';

export function minCheckboxSelected(min: number) {
    return (c: UntypedFormControl): {[key: string]: any} => {
        const arrayTrueValue = c.value.filter(x => x);

        if (arrayTrueValue.length >= min) {
          return null;
        }

        return { minCheckboxSelected: {valid: false }};
    };
}
